import styled from 'styled-components';

import {
  FieldInput,
  FieldError
} from '@CS/components/Form/InputField/InputField.styles';

export const UsernameContainer = styled.div`
  padding: min(9.3vmin, 35px) 1rem min(11.2vmin, 42px);
  background-color: rgb(255 255 255);

  background-clip: content-box;
  justify-content: flex-start;

  flex-direction: column;
  align-content: center;
  align-items: center;

  position: relative;
  flex-wrap: nowrap;
  overflow: hidden;

  display: flex;
  height: auto;
  width: 100%;
`;

export const UsernameTitle = styled.h3`
  text-transform: uppercase;
  margin-bottom: 2rem;
  font-size: 1.75rem;

  line-height: 1.125;
  text-align: center;
  position: relative;
  color: rgb(0 0 0);

  display: block;
  height: auto;
  width: 100%;
`;

export const UsernameDescription = styled.p`
  margin: 1rem auto 1.5rem;
  line-height: 1.25rem;
  color: rgb(34 34 34);

  text-align: center;
  position: relative;
  padding: 0 0.5rem;
  font-size: 1rem;

  display: block;
  height: auto;
  width: 100%;
`;

export const UsernameInput = styled(FieldInput)`
  &&& {
    background-color: rgb(240 240 240);
    border-color: rgb(187 187 187);
    margin-bottom: 2rem;

    &:focus,
    &:active {
      border-color: rgb(127 127 127);
    }
  }
`;

export const UsernameError = styled(FieldError)`
  &&& {
    margin: -1.5rem 0 2rem;
  }
`;
